var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaidEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.286,
    height: 68.286,
    viewBox: "0 0 68.286 68.286",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2142",
    "data-name": "Group 2142",
    transform: "translate(-1007 -337)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coin",
    transform: "translate(1007 337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0H68.286V68.286H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M18.194,10.731h3.969A1.366,1.366,0,0,1,23.529,12.1v1.034a1.366,1.366,0,0,1-2.691.332h-6.7a1.366,1.366,0,0,0-1.366,1.366V16.2a1.366,1.366,0,0,0,1.366,1.366H19.56a4.1,4.1,0,0,1,4.1,4.1v1.364a4.1,4.1,0,0,1-4.1,4.1H18.194v1.342a1.366,1.366,0,0,1-2.731,0V27.12h-4.1A1.366,1.366,0,0,1,10,25.713l.038-1.252a1.366,1.366,0,0,1,2.726-.072h6.8a1.366,1.366,0,0,0,1.366-1.366V21.659a1.366,1.366,0,0,0-1.366-1.366H14.135a4.1,4.1,0,0,1-4.1-4.1V14.829a4.1,4.1,0,0,1,4.1-4.1h1.328V9.366a1.366,1.366,0,1,1,2.731,0Z",
    transform: "translate(17.314 13.851)",
    fill: "#fe9920"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    "data-name": "path",
    d: "M30.68,2A28.68,28.68,0,1,1,2,30.68,28.68,28.68,0,0,1,30.68,2Zm0,2.731A25.949,25.949,0,1,0,56.629,30.68,25.949,25.949,0,0,0,30.68,4.731Zm0,5.463A20.486,20.486,0,1,1,10.194,30.68,20.486,20.486,0,0,1,30.68,10.194Zm0,2.731A17.754,17.754,0,1,0,48.434,30.68,17.754,17.754,0,0,0,30.68,12.926Z",
    transform: "translate(3.463 3.463)",
    fill: "#0c4767"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-4",
    "data-name": "path",
    d: "M30.68,2A28.68,28.68,0,1,1,2,30.68,28.68,28.68,0,0,1,30.68,2ZM4.731,30.68Z",
    transform: "translate(1013.462 343.463)",
    fill: "#fe9920",
    opacity: 0.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidEvent);
export default __webpack_public_path__ + "static/media/paid-event.046311ae325715e04f2050478cb3f6d8.svg";
export { ForwardRef as ReactComponent };